var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatFlowchatBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1503",
    "data-name": "Group 1503",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.472,
    height: 17.472,
    viewBox: "0 0 17.472 17.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #027aaa;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    className: "cls-1",
    cx: 8.736,
    cy: 8.736,
    r: 8.736
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-robot",
    "data-name": "Icon awesome-robot",
    className: "cls-2",
    d: "M0,4.434V6.651A.554.554,0,0,0,.554,7.2h.554V3.879H.554A.554.554,0,0,0,0,4.434ZM8.036,1.663H6.1V.554a.554.554,0,1,0-1.108,0V1.663H3.048A1.385,1.385,0,0,0,1.663,3.048V7.759A1.109,1.109,0,0,0,2.771,8.867H8.313A1.109,1.109,0,0,0,9.422,7.759V3.048A1.385,1.385,0,0,0,8.036,1.663ZM4.434,7.2H3.325V6.651H4.434ZM3.879,5.126a.693.693,0,1,1,.693-.693A.693.693,0,0,1,3.879,5.126ZM6.1,7.2H4.988V6.651H6.1Zm1.663,0H6.651V6.651H7.759ZM7.2,5.126A.693.693,0,1,1,7.9,4.434.693.693,0,0,1,7.2,5.126ZM10.53,3.879H9.976V7.2h.554a.554.554,0,0,0,.554-.554V4.434A.554.554,0,0,0,10.53,3.879Z",
    transform: "translate(3.435 3.944)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFlowchatBot);
export default __webpack_public_path__ + "static/media/chatFlowchatBot.cdfb1b2bf34b72cef40eb324c6e1e815.svg";
export { ForwardRef as ReactComponent };